import * as React from "react";
import { useState } from "react";

import { Field, withTypes } from "react-final-form";

import axios from "axios";

import {
  Button,
  CardActions,
  CircularProgress,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import {
  Notification, useTranslate, useNotify
} from "react-admin";


import { ENDPOINTS } from "../apiConstants";
import { getConfigGet } from "../getConfig";

const useStyles = makeStyles((theme) => ({
  main: {
    display: "flex",
    flexDirection: "column",
    minHeight: "50vh",
    alignItems: "center",
    justifyContent: "flex-start",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    width: "100%",
    padding: "0 1em",
  },
  para: {
    marginBottom: '0px'
  },
  input_container: {
    display: "flex"
  },
  avatar: {
    margin: "1em",
    display: "flex",
    justifyContent: "center",
  },
  icon: {
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    padding: "0 1em 1em 1em",
  },
  input: {
    marginTop: "1em",
    marginLeft: "1em",
    minWidth: 100
  },
  actions: {
    padding: "0 1em 1em 1em",
  },
  tableWrapper: {
    width: "100%",
  },
  table: {
    border: "1px solid lightgray",
    borderCollapse: "collapse" as const,
  },
  tdStyle: {
    '& td, th': {
      border: "1px solid #e0e0e0",
      padding: "6px 12px",
      minHeight: "30px",
      textAlign: "center" as const,
      fontSize: "0.85em",
      minWidth: "90px",
      wordBreak: "break-word" as const,
    }
  },
  thStyle: {
    '& th': {
      backgroundColor: "#f5f5f5",
      fontWeight: 600,
      textTransform: "capitalize" as const,
    }
  },
  updateSection: {
    marginTop: "2em",
    marginLeft: "auto",
    marginRight: "auto",
    padding: "1.5em",
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    backgroundColor: "#f9f9f9",
    maxWidth: "600px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  updateTitle: {
    fontSize: "1.2em",
    fontWeight: 500,
    marginBottom: "1em",
    color: "#333",
    textAlign: "center"
  },
  formControl: {
    marginTop: "1em",
    minWidth: "100%"
  },
  warningText: {
    marginTop: "2em",
    padding: "1em",
    backgroundColor: "#fff3cd",
    border: "1px solid #ffc107",
    borderRadius: "4px",
    color: "#856404",
    textAlign: "center"
  }
}));

const renderInput = ({
  meta: { touched, error } = { touched: false, error: undefined },
  input: { ...inputProps },
  ...props
}) => (
  <TextField
    error={!!(touched && error)}
    helperText={touched && error}
    {...inputProps}
    {...props}
    fullWidth
  />
);

interface FormValues {
  email?: string;
}

const { Form } = withTypes<FormValues>();

const UserMortgageData = () => {
  const [loading] = useState(false);
  const translate = useTranslate();
  const classes = useStyles();
  const notify = useNotify();

  const [mortgageDetail, setmortgageDetail] = useState<any[]>([]);
  const [selectedMortgageId, setSelectedMortgageId] = useState<number | "">("");
  const [currentEmail, setCurrentEmail] = useState("");
  const [updateField, setUpdateField] = useState("");
  const [updateValue, setUpdateValue] = useState("");
  const [updating, setUpdating] = useState(false);
  const [endingMortgageId, setEndingMortgageId] = useState<number | null>(null);
  const [removingEndDateId, setRemovingEndDateId] = useState<number | null>(null);

  const userMortgage = (inputData: any) => {
    setmortgageDetail([])
    setSelectedMortgageId("")
    setCurrentEmail(inputData.email)
    setUpdateField("")
    setUpdateValue("")
    let config = getConfigGet({ email: inputData.email })

    axios.get(ENDPOINTS.USER_MORTGAGE_DATA, config)
      .then((res: any) => {
        const mortgages = res.data || res.data.mortgages;
        setmortgageDetail(mortgages);
        
        const selected = mortgages.find((m: any) => m.is_selected === 'Selected');
        if (selected) {
          setSelectedMortgageId(selected.id);
        }
        
        notify('Success', "info", "", undefined, 50000);
      })
      .catch((error) => {
        notify(error?.response?.data?.message || 'Error while getting mortgage data', "error", "", undefined, 50000)
      });
  };

  const chosenMortgage = mortgageDetail.find((m: any) => m.id === selectedMortgageId) || null;
  const isChosenSelected = chosenMortgage?.is_selected === 'Selected';

  const updateMortgage = () => {
    if (!updateField || !updateValue) {
      notify('Please select a field and enter a value', "warning", "", undefined, 3000);
      return;
    }

    if (!selectedMortgageId || !currentEmail) {
      notify('Please select a mortgage', "error", "", undefined, 3000);
      return;
    }

    setUpdating(true);

    const config = getConfigGet({ email: currentEmail });
    const updateData = {
      field: updateField,
      value: parseFloat(updateValue)
    };
    
    axios.patch(`${ENDPOINTS.USER_MORTGAGE_DATA}/${selectedMortgageId}`, updateData, config)
      .then((res: any) => {
        notify('Mortgage updated successfully', "success", "", undefined, 3000);
        setUpdateField("");
        setUpdateValue("");
        userMortgage({ email: currentEmail });
      })
      .catch((error) => {
        notify(error?.response?.data?.message || 'Error updating mortgage', "error", "", undefined, 5000);
      })
      .finally(() => {
        setUpdating(false);
      });
  };

  const endMortgage = (mortgageId: number) => {
    if (!currentEmail) {
      notify('No user email found', "error", "", undefined, 3000);
      return;
    }

    setEndingMortgageId(mortgageId);

    const config = getConfigGet({ email: currentEmail });
    const today = new Date().toISOString().split('T')[0];
    const updateData = {
      field: 'end_date',
      value: today
    };

    axios.patch(`${ENDPOINTS.USER_MORTGAGE_DATA}/${mortgageId}`, updateData, config)
      .then((res: any) => {
        notify('Mortgage ended successfully', "success", "", undefined, 3000);
        userMortgage({ email: currentEmail });
      })
      .catch((error) => {
        notify(error?.response?.data?.message || 'Error ending mortgage', "error", "", undefined, 5000);
      })
      .finally(() => {
        setEndingMortgageId(null);
      });
  };

  const removeEndDate = (mortgageId: number) => {
    if (!currentEmail) {
      notify('No user email found', "error", "", undefined, 3000);
      return;
    }

    setRemovingEndDateId(mortgageId);

    const config = getConfigGet({ email: currentEmail });
    const updateData = {
      field: 'end_date',
      value: null
    };

    axios.patch(`${ENDPOINTS.USER_MORTGAGE_DATA}/${mortgageId}`, updateData, config)
      .then((res: any) => {
        notify('End date removed successfully', "success", "", undefined, 3000);
        userMortgage({ email: currentEmail });
      })
      .catch((error) => {
        notify(error?.response?.data?.message || 'Error removing end date', "error", "", undefined, 5000);
      })
      .finally(() => {
        setRemovingEndDateId(null);
      });
  };

  const validate = (values: FormValues) => {
    const errors: FormValues = {};
    if (!values.email) {
      errors.email = translate("ra.validation.required");
    }
    return errors;
  };

  let resultHeaders = ['account no', 'masked account no', 'start date', 'lender', 'current balance amount', 'fixed payment amount', 'term remaining in months', 'interest rate (%)', 'end date', 'is selected mortgage', 'offset mortgage', 'title', 'first name', 'last name', 'data source', 'actions'];

  return (
    <>
      <Form
        onSubmit={userMortgage}
        validate={validate}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit} noValidate>
            <div className={classes.main}>
              <div className={classes.form}>
                <div className={classes.input_container}>
                  <Field
                    autoFocus
                    name="email"
                    // @ts-ignore
                    component={renderInput}
                    label={translate("pos.email")}
                    disabled={loading}
                  />
                </div>
              </div>
              <CardActions className={classes.actions}>
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  disabled={loading}
                  fullWidth
                >
                  {loading && <CircularProgress size={25} thickness={2} />}
                  User mortgage data
                </Button>
              </CardActions>
              <p>Note: Provides all active mortgages from DB for user</p>
              {mortgageDetail.length ?
                <div>
                  <div className={classes.tableWrapper}>
                    <table className={classes.table}>
                      <thead>
                        <tr className={`${classes.tdStyle} ${classes.thStyle}`}>
                          {resultHeaders.map((header, idx) => (
                            <th key={idx}>{header}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {mortgageDetail.map((t: any) => (
                          <tr className={classes.tdStyle} key={t.id}>
                            <td>{t.decryptedAccountNumber}</td>
                            <td>{t.maskedAccountNumber}</td>
                            <td>{t.start_date}</td>
                            <td>{t.company_name}</td>
                            <td>{t.current_balance_amount}</td>
                            <td>{t.fixed_payment_amount}</td>
                            <td>{t.termRemining || t.fixed_payment_count}</td>
                            <td>{t.interest_rate !== null && t.interest_rate !== undefined ? t.interest_rate : 'N/A'}</td>
                            <td>{t.end_date || '-'}</td>
                            <td>{t.is_selected}</td>
                            <td>{t.is_offset_mortgage}</td>
                            <td>{t.title}</td>
                            <td>{t.first_name}</td>
                            <td>{t.last_name}</td>
                            <td>{t.data_source}</td>
                            <td>
                              {!t.end_date ? (
                                <Button
                                  variant="outlined"
                                  color="secondary"
                                  size="small"
                                  onClick={() => endMortgage(t.id)}
                                  disabled={endingMortgageId === t.id}
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  {endingMortgageId === t.id ? (
                                    <CircularProgress size={16} thickness={2} />
                                  ) : (
                                    'End Mortgage'
                                  )}
                                </Button>
                              ) : (
                                <Button
                                  variant="outlined"
                                  size="small"
                                  onClick={() => removeEndDate(t.id)}
                                  disabled={removingEndDateId === t.id}
                                  style={{ whiteSpace: "nowrap", color: '#1976d2', borderColor: '#1976d2' }}
                                >
                                  {removingEndDateId === t.id ? (
                                    <CircularProgress size={16} thickness={2} />
                                  ) : (
                                    'Remove End Date'
                                  )}
                                </Button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* Update Form */}
                  <div className={classes.updateSection}>
                    <div className={classes.updateTitle}>
                      Update Mortgage
                    </div>

                    <FormControl className={classes.formControl} variant="outlined">
                      <InputLabel id="mortgage-select-label" shrink={!!selectedMortgageId}>Select Mortgage</InputLabel>
                      <Select
                        labelId="mortgage-select-label"
                        value={selectedMortgageId}
                        displayEmpty
                        onChange={(e) => {
                          setSelectedMortgageId(e.target.value as number);
                          setUpdateField("");
                          setUpdateValue("");
                        }}
                      >
                        <MenuItem value="" disabled>
                          <em>Choose a mortgage...</em>
                        </MenuItem>
                        {mortgageDetail.filter((m: any) => !m.end_date).map((m: any) => (
                          <MenuItem key={m.id} value={m.id}>
                            {m.company_name} — {m.decryptedAccountNumber || m.maskedAccountNumber || m.id}
                            {m.is_selected === 'Selected' ? ' ★' : ''}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    {chosenMortgage && (
                      <p style={{ margin: "0.5em 0", color: "#666", textAlign: "center", fontSize: "0.85em" }}>
                        Balance: £{chosenMortgage.current_balance_amount || 'N/A'} &nbsp;|&nbsp; Payment: £{chosenMortgage.fixed_payment_amount || 'N/A'} &nbsp;|&nbsp; {isChosenSelected ? '✔ Selected Mortgage' : 'Not the selected mortgage'}
                      </p>
                    )}

                    <FormControl className={classes.formControl} disabled={!selectedMortgageId}>
                      <InputLabel id="field-select-label">Field to Update</InputLabel>
                      <Select
                        labelId="field-select-label"
                        value={updateField}
                        onChange={(e) => {
                          setUpdateField(e.target.value as string);
                          setUpdateValue("");
                        }}
                      >
                        <MenuItem value="current_balance_amount">Current Balance</MenuItem>
                        <MenuItem value="fixed_payment_amount">Monthly Payment</MenuItem>
                        <MenuItem value="remaining_term_months">Remaining Term (months)</MenuItem>
                        <MenuItem value="interest_rate" disabled={!isChosenSelected}>
                          Interest Rate (%) {!isChosenSelected ? '— selected mortgage only' : ''}
                        </MenuItem>
                      </Select>
                    </FormControl>

                    {updateField === 'interest_rate' && !isChosenSelected && (
                      <p style={{ margin: "0.5em 0", color: "#d32f2f", fontSize: "0.8em", textAlign: "center" }}>
                        Interest rate can only be updated for the selected mortgage.
                      </p>
                    )}

                    <TextField
                      className={classes.formControl}
                      label={
                        updateField === 'remaining_term_months' ? 'Total remaining months' :
                        updateField === 'interest_rate' ? 'Rate (e.g. 4.5)' :
                        'New Value'
                      }
                      type="number"
                      value={updateValue}
                      onChange={(e) => setUpdateValue(e.target.value)}
                      fullWidth
                      disabled={!updateField || !selectedMortgageId}
                      inputProps={{
                        step: updateField === "interest_rate" ? "0.01" : "1",
                        min: updateField === "remaining_term_months" ? "1" : undefined,
                      }}
                      onKeyDown={(e) => {
                        if (
                          updateField !== "interest_rate" &&
                          (e.key === "." || e.key === ",")
                        ) {
                          e.preventDefault();
                        }
                      }}
                    />

                    <Button
                      variant="contained"
                      color="primary"
                      onClick={updateMortgage}
                      disabled={!selectedMortgageId || !updateField || !updateValue || updating}
                      fullWidth
                      style={{ marginTop: "1.5em" }}
                    >
                      {updating && <CircularProgress size={20} thickness={2} style={{ marginRight: "0.5em" }} />}
                      Update Mortgage
                    </Button>
                  </div>

                </div> : null}
              <Notification />
            </div>

          </form>
        )}
      />

    </>
  );
};

export default UserMortgageData;
